<template>
  <Head :title="__('download.meta.title')">
    <meta
      name="description"
      :content="__('download.meta.description', {vip: shoutOut.vip.content.display_name})"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.shout-out.download', [shoutOut])"
    >
    <meta
      property="og:title"
      :content="__('download.meta.title')"
    >
    <meta
      property="og:description"
      :content="__('download.meta.description', {vip: shoutOut.vip.content.display_name})"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <div :style="partnerStyle">
    <section class="header-download">
      <div class="container">
        <div class="py-5">
          <Link
            :href="localeRoute('frontend.index')"
            class="block"
          >
            <img
              v-if="partner && partner.logo"
              :src="partner.logo.url"
              :alt="`${partner.name} logo`"
              class="mx-auto"
            >
            <img
              v-else
              src="/frontend/assets/logo.svg"
              :alt="__('download.logo')"
              class="mx-auto"
            >
          </Link>
        </div>
      </div>
    </section>

    <section class="download relative">
      <img
        src="/frontend/assets/desktop-hero-swirl.svg"
        class="absolute top-0 left-0 hidden lg:block"
      >

      <div class="container relative z-10">
        <div class="pt-7 pb-4 md:hidden">
          <h1 class="text-2xl font-bold text-center sparkle-left ">
            {{ __('download.title') }}<br>
            {{ __('download.from', {vip: shoutOut.vip.content.display_name}) }}
          </h1>
        </div>

        <div
          class="bg-white p-6 rounded-lg grid grid-cols-1 md:grid-cols-5 md:gap-8 lg:gap-16 md:bg-red-100 md:p-0 md:mt-10"
          :style="partnerStyle"
        >
          <div class="md:col-span-3">
            <div class="grid justify-items-center">
              <div
                v-if="shoutOut.video"
                class="pb-5 md:shadow-vip-desktop rounded-xl overflow-hidden md:pb-0"
              >
                <video
                  controls
                  class="max-h-[460px] md:max-h-[720px]"
                  @ended="ended"
                >
                  <source
                    :src="shoutOut.video.url+'?uuid='+shoutOut.uuid"
                    type="video/mp4"
                  >
                  {{ __('components.video-player.not-supported') }}
                </video>
              </div>
            </div>
          </div>

          <div class="md:col-span-2 md:flex md:content-center md:flex-wrap">
            <h1 class="hidden text-4xl font-bold md:block w-full md:text-left mb-4 pb-4 border-b border-black">
              {{ __('download.title') }}<br>
              {{ __('download.from', {vip: shoutOut.vip.content.display_name}) }}
            </h1>
            <p class="font-medium w-full md:left-text">
              {{ __('download.made-by', {vip: shoutOut.vip.first_name, for: shoutOut.for}) }}
              <span v-if="partner && partner.name">
                <br>{{ __('download.partner', {partner: partner.name}) }}
              </span>
            </p>

            <Rating
              v-if="!partner"
              :initial-rating="shoutOut.rating"
              :shout-out="shoutOut"
            />
            <div class="w-full lg:text-center lg:w-3/5">
              <button
                type="button"
                class="button-green shadow-button-black w-full block lg:inline-block "
                @click="share"
              >
                {{ __('download.share') }}
                <img
                  src="/frontend/assets/share.svg"
                  class="inline ml-2"
                >
              </button>

              <a
                v-if="shoutOut.video && !partner"
                :href="localeRoute('frontend.shout-out.download-video', [shoutOut]) + '?uuid=' + shoutOut.uuid"
                class="button-white-outline shadow-button-red-sec mt-8 w-full block lg:inline-block md:mt-4"
                target="_blank"
              >
                {{ __('download.download') }}
                <img
                  src="/frontend/assets/download.svg"
                  class="inline ml-2"
                >
              </a>

              <a
                v-if="shoutOut.video && !partner && !shoutOut.no_logo"
                :href="localeRoute('frontend.order.without-logo', [shoutOut])"
                class="button-orange shadow-button-black mt-8 w-full block lg:inline-block md:mt-4"
              >
                ShoutOut zonder logo &euro;7,50
              </a>
            </div>
            <div class="w-full text-center lg:w-3/5 mt-4">
              <div class="mt-1 text-gray-500 text-center">
                Ik kan niet downloaden &nbsp;
                <div class="relative inline-block has-tooltip w-[15px] h-[15px] mr-1 pt-1">
                  <div class="tooltip relative left-5 rounded shadow-lg p-3 bg-white w-[300px] font-normal text-left">
                    <div class="mb-2">
                      Bij grote bestanden opent de mediaspeler automatisch. Om toch te downloaden:
                    </div>
                    <div>
                      - Klik op Download ShoutOut knop
                    </div>
                    <div>
                      - Klik op de 3 puntjes
                    </div>
                    <div>
                      - Klik op Downloaden
                    </div>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  ><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" /></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="download-vips py-14">
      <img
        src="/frontend/assets/scribble.svg"
        class="hidden lg:block mx-auto my-4 lg:my-12 lg:h-[75px]"
      >

      <div class="container">
        <div class="text-center">
          <h2 class="text-2xl font-bold mb-2 md:text-5xl">
            {{ __('download.surprise.title') }}
          </h2>
          <p
            class="md:text-lg"
          >
            {{ __('download.surprise.text') }}
          </p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-2 gap-4 lg:gap-8 mt-6">
          <Vip
            v-for="alternativeVip in alternativeVips"
            :key="`vip-${alternativeVip.username}`"
            :vip="alternativeVip"
          />
        </div>

        <div class="text-center mt-12 relative">
          <img
            src="/frontend/assets/scribble-bottom.svg"
            class="absolute bottom-[10px] -right-[15px] lg:hidden"
          >
          <img
            src="/frontend/assets/scribble-bottom-desktop.svg"
            class="hidden lg:block lg:absolute lg:-right-[100px] lg:bottom-[10px]"
          >

          <Link
            :href="localeRoute('frontend.index')"
            class="button-orange shadow-button-black inline-block"
          >
            {{ __('general.see-all-vips') }}
          </Link>
        </div>
      </div>
    </section>
  </div>

  <TransitionRoot
    as="template"
    :show="newsletterModal"
  >
    <DialogComponent
      as="div"
      class="relative z-50"
      @close="newsletterModal = false"
    >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-400 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div
        v-if="newsletterModal"
        class="fixed inset-0 z-10 overflow-y-auto"
      >
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="w-full md:w-1/3 max-w-screen inline-block md:mt-36 align-bottom bg-white rounded-xl text-left overflow-hidden shadow transform transition-all md:align-middle md:max-w-screen-lg mx-10"
            >
              <div class="absolute top-2.5 right-2.5 cursor-pointer flex flex-col items-center z-50">
                <button @click="newsletterModal = false">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div
                v-if="newsletterSuccess"
                class="p-6"
              >
                <span class="text-2xl font-bold block text-center lg:text-xl lg:text-left">
                  {{ __('download.newsletter.success') }}
                </span>
              </div>
              <div
                v-else
                class="p-6"
              >
                <span class="text-2xl font-bold block text-center lg:text-xl lg:text-left">
                  {{ __('download.newsletter.title') }}
                </span>

                <p>
                  {{ __('download.newsletter.text') }}
                </p>

                <form
                  class="w-full mt-3"
                  @submit.prevent="form.post(localeRoute('frontend.newsletter.store'), {
                    preserveScroll: true,
                    onSuccess: () => {
                      form.reset();
                      newsletterSuccess = true;
                    }
                  })"
                >
                  <div class="md:flex">
                    <div class="grow">
                      <input
                        id="email"
                        v-model="form.email"
                        type="email"
                        name="email"
                        class="block w-full rounded-lg border-black p-4 border-2 placeholder-gray-300 focus:ring-red focus:ring-offset-red focus:border-red"
                        :placeholder="__('download.newsletter.email.placeholder')"
                      >
                    </div>
                    <div class="ml-0 mt-3 md:ml-3 md:mt-0">
                      <button
                        type="submit"
                        class="!py-4 w-full button-orange shadow-button-red block"
                      >
                        {{ __('download.newsletter.submit') }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </DialogComponent>
  </TransitionRoot>
</template>

<script>
import {Dialog as DialogComponent, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {useForm} from '@inertiajs/vue3';
import CleanWithFooter from '../../Layout/CleanWithFooter.vue';
import Vip from '../../Components/Vip.vue';
import Rating from '../../Components/Rating.vue';

export default {
  components: {
    TransitionChild,
    TransitionRoot,
    DialogPanel,
    DialogComponent,
    Vip,
    Rating,
  },

  layout: CleanWithFooter,

  props: {
    shoutOut: {
      type: Object,
      required: true,
    },

    alternativeVips: {
      type: Array,
      required: true,
    },

    partner: {
      type: Object,
      required: false,
      default: null,
    },

    giftedDiscountCode: {
      type: Object,
      required: false,
      default: null,
    },
  },

  setup() {
    const form = useForm({email: ''});

    return {form};
  },

  data() {
    const partnerStyle = {};

    if (this.partner) {
      partnerStyle['background-color'] = this.partner.color;
      partnerStyle['color'] = this.partner.text_color;
    }

    return {
      partnerStyle,
      selectedRating: null,
      newsletterShown: false,
      newsletterModal: false,
      newsletterSuccess: false,
    };
  },

  methods: {
    share() {
      if (navigator.share) {
        navigator.share({
          title: this.__('download.meta.description', {vip: this.shoutOut.vip.content.display_name}),
          url: window.location,
        });
      }

      // @todo implement fallback
    },

    ended () {
      if (this.partner && !this.newsletterShown) {
        this.newsletterShown = true;
        setTimeout(() => this.newsletterModal = true, 5000);
      }
    },
  },
};
</script>
